import { useEffect } from 'react';
import { useMetadata, useProduct } from '@thd-nucleus/data-sources';
import {
  ITEM_DOMAINS, SAMPLE_DOMAINS
} from '../constants';

export const useMultipleSamples = ({ parentId, storeId, zipCode }) => {
  const [metaReq, metadataResponse] = useMetadata({
    parentId,
    lazy: true,
  });

  useEffect(() => {
    if (parentId) {
      metaReq({ variables: { parentId } });
    }
  }, [parentId]);

  const childItems = metadataResponse?.data?.metadata?.childItemsLookup || [];
  const itemIds = childItems
    .filter((item) => item.itemId !== null)
    .map((item) => item.itemId);

  let [productRequst, productResponse] = useProduct({
    lazy: true,
    itemIds,
    domains: ITEM_DOMAINS,
    storeId,
  });
  useEffect(() => {
    if (itemIds?.length) {
      productRequst();
    }
  }, [itemIds?.length]);

  const { products = [] } = productResponse?.data || {};
  const sampleIds = products
    .filter((product) => product?.identifiers?.sampleId !== null)
    .map((product) => product?.identifiers?.sampleId);

  const [sampleRequest, samplesResponse] = useProduct({
    itemIds: sampleIds,
    lazy: true,
    domains: SAMPLE_DOMAINS,
    storeId,
    zipCode
  });

  useEffect(() => {
    if (storeId && sampleIds?.length) {
      sampleRequest();
    }
  }, [sampleIds?.length, storeId]);

  const normalizeImageUrl = (url, size) => {
    const urlRE = /<SIZE>/i;
    return url.replace(urlRE, size);
  };

  const { products: sampleProducts } = samplesResponse?.data || {};
  let orderSamples;
  if (sampleProducts && sampleProducts.length) {
    orderSamples = sampleProducts.map((product) => {
      const {
        availabilityType, fulfillment, itemId, media, pricing, specificationGroup
      } = product || {};
      const details = specificationGroup?.find((spec) => spec.specTitle === 'Details');
      let color = details?.specifications?.find((spec) => spec.specName === 'Color/Finish')?.specValue;

      // only want to to do this if we do not have a Color/Finish
      if (!color) {
        color = details?.specifications?.find((spec) => spec.specName === 'Color Family')?.specValue;
      }

      const imageObject = media?.images.find((image) => image.subType === 'PRIMARY');
      const imgUrl = imageObject?.url;
      const imgSize = imageObject?.sizes.find((size) => size === '400');
      const inStockStatus = fulfillment?.fulfillmentOptions;
      const discontinued = availabilityType?.discontinued;
      const price = pricing?.value;

      return {
        itemId,
        color,
        imgUrl: normalizeImageUrl(imgUrl, imgSize),
        inStockStatus,
        discontinued,
        price
      };
    });
  }

  return {
    data: { orderSamples },
    loading: productResponse?.loading || metadataResponse?.loading || samplesResponse?.loading,
    error: productResponse?.error || metadataResponse?.error || samplesResponse?.error,
  };
};
